import { SxProps, Theme } from '@mui/material';
import { SPACING } from '../../styles';

export const headerSectionStyles: SxProps<Theme> = {
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
  mt: SPACING.LARGE,
  mb: SPACING.MEDIUM,
};
